export const XERO_ERROR_MESSAGES = {
  CONNECTION_FAILED: "Failed to connect with Xero",
};

export const XERO_INFO_MESSAGES = {
  XERO_CONNECTED: "Xero is connected with this workspace",
  XERO_DISCONNECTED: "Xero is disconnected with this workspace",
  ALREADY_CONNECTED: "Xero is already connected with this workspace",
};

export enum XERO_INVOICE_STATUS {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  AUTHORISED = "AUTHORISED",
  VOIDED = "VOIDED",
  DELETED = "DELETED",
}

export enum XERO_INVOICE_ALLOCATION_METHOD {
  CRM = "CRM",
  XERO = "XERO",
}
